import withName from "../../hoc/withName";
import { useTranslation } from "react-i18next";
import { SERVICE_DATAPLAN, SERVICE_DROPCONTROL, SERVICE_EXT_DATASOURCE, LABEL_NODOS, SERVICE_ADDITIONAL_USER, SERVICE_SMS_CALLS, SERVICE_IMAGES, SERVICE_ADDITIONAL_API, SERVICE_DROPCONTROL_FREE, SERVICE_DROPCONTROL_LITE, SERVICE_DROPCONTROL_DROPCONTROL, SERVICE_DROPCONTROL_PREMIUM, SERVICE_DROPCONTROL_API } from "../../utils/BillingUtils";
import { TabView, TabPanel } from "primereact/tabview";
import { InputNumber } from "primereact/inputnumber";


const ServiceForm = ({service, values, setFieldValue, indexes}) => {
    const { t } = useTranslation();
    const minDecimals = 0;
    const maxDecimals = 4;
    function capitalizeString(input) {
        return input.toLowerCase().replace(/(^|\s)\S/g, (match) => match.toUpperCase());
    }
    return (
        <>
            {service === SERVICE_DROPCONTROL?
                <TabView className='servDCtabs col-xl-12 col-lg-12 col-sm-12 text-center'>
                    <TabPanel header={t("billing.dropLite")} className=''>
                        {Object.keys(values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_LITE]??[]).map((item, index) => {
                            if(item==="FREE") return null;
                            return(<div key={"DCL"+index} className="row linea-formulario">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{item}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <InputNumber className="buttonMidWidth"
                                        name={`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_LITE}.${item}`}
                                        value={values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_LITE]?.[item]}
                                        onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_LITE}.${item}`,e.value)}
                                        minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                                    />
                                </div>
                                <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label >USD</label>
                                </div>
                            </div>);
                        })}
                    </TabPanel>
                    <TabPanel header={t("billing.dropPlus")} className=''>
                        {Object.keys(values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_DROPCONTROL]??[]).map((item, index) => {
                            if(item==="FREE") return null;
                            return(<div key={"DCD"+index} className="row linea-formulario">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{item}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <InputNumber className="buttonMidWidth"
                                        name={`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_DROPCONTROL}.${item}`}
                                        value={values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_DROPCONTROL]?.[item]}
                                        onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_DROPCONTROL}.${item}`,e.value)}
                                        minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                                    />
                                </div>
                                <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label >USD</label>
                                </div>
                            </div>);
                        })}
                    </TabPanel>
                    <TabPanel header={t("billing.dropPrem")} className=''>
                        {Object.keys(values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_PREMIUM]??[]).map((item, index) => {
                            if(item==="FREE") return null;
                            return(<div key={"DCP"+index} className="row linea-formulario">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{item}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <InputNumber className="buttonMidWidth"
                                        name={`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_PREMIUM}.${item}`}
                                        value={values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_PREMIUM]?.[item]}
                                        onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_PREMIUM}.${item}`,e.value)}
                                        minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                                    />
                                </div>
                                <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label >USD</label>
                                </div>
                            </div>);
                        })}
                    </TabPanel>
                    <TabPanel header={t("billing.dropAPI")} className=''>
                        {Object.keys(values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_API]??[]).map((item, index) => {
                            if(item==="FREE") return null;
                            return(<div key={"DCA"+index} className="row linea-formulario">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{item}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <InputNumber className="buttonMidWidth"
                                        name={`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_API}.${item}`}
                                        value={values?.precios?.[indexes[SERVICE_DROPCONTROL]]?.config?.[SERVICE_DROPCONTROL_API]?.[item]}
                                        onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_DROPCONTROL]}.config.${SERVICE_DROPCONTROL_API}.${item}`,e.value)}
                                        minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                                    />
                                </div>
                                <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label >USD</label>
                                </div>
                            </div>);
                        })}
                    </TabPanel>
                </TabView>
                :null}
            {service === SERVICE_DATAPLAN?
                <>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.value")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_DATAPLAN]}.valor`} min={0}
                                value={values?.precios?.[indexes[SERVICE_DATAPLAN]]?.valor}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_DATAPLAN]}.valor`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                </>
                :null}
            {service === SERVICE_EXT_DATASOURCE?
                <>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.default_value")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_EXT_DATASOURCE]}.valor`} min={0}
                                value={values?.precios?.[indexes[SERVICE_EXT_DATASOURCE]]?.valor}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_EXT_DATASOURCE]}.valor`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                    {Object.keys(values?.precios?.[indexes[SERVICE_EXT_DATASOURCE]]?.config).map((item, index) => {
                        if(item !== "14") {
                            return(
                                <div key={"Ext"+index} className="row linea-formulario">
                                    <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                                        <label className="boldie">{LABEL_NODOS[item]}</label>
                                    </div>
                                    <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                                        <InputNumber className="buttonMidWidth"
                                            name={`precios.${indexes[SERVICE_EXT_DATASOURCE]}.config.${item}`}
                                            value={values?.precios?.[indexes[SERVICE_EXT_DATASOURCE]]?.config?.[item]}
                                            onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_EXT_DATASOURCE]}.config.${item}`,e.value)}
                                            minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                                        />
                                    </div>
                                    <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                        <label >USD</label>
                                    </div>
                                </div>
                            );
                        }
                        else{
                            return(
                                Object.keys(values?.precios?.[indexes[SERVICE_EXT_DATASOURCE]]?.config?.[item]).map((item2, index) => (
                                    <div key={"Ext"+index} className="row linea-formulario">
                                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                                            <label className="boldie">{item2==="default"?t("billing.generic"):capitalizeString(item2)}</label>
                                        </div>
                                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                                            <InputNumber className="buttonMidWidth"
                                                name={`precios.${indexes[SERVICE_EXT_DATASOURCE]}.config.${item}.${item2}`}
                                                value={values?.precios?.[indexes[SERVICE_EXT_DATASOURCE]]?.config?.[item]?.[item2]}
                                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_EXT_DATASOURCE]}.config.${item}.${item2}`,e.value)}
                                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                                            />
                                        </div>
                                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                            <label >USD</label>
                                        </div>
                                    </div>
                                )
                                )
                            );
                        }
                    })}
                </>
                :null}
            {service === SERVICE_ADDITIONAL_USER?
                <>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.farmUser")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_ADDITIONAL_USER]}.config.farmUser`}
                                value={values?.precios?.[indexes[SERVICE_ADDITIONAL_USER]]?.config?.farmUser}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_ADDITIONAL_USER]}.config.farmUser`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.clientUser")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_ADDITIONAL_USER]}.config.clientUser`}
                                value={values?.precios?.[indexes[SERVICE_ADDITIONAL_USER]]?.config?.clientUser}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_ADDITIONAL_USER]}.config.clientUser`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                </>
                :null}
            {service === SERVICE_SMS_CALLS?
                <>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.sms")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_SMS_CALLS]}.config.SMS`}
                                value={values?.precios?.[indexes[SERVICE_SMS_CALLS]]?.config?.SMS}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_SMS_CALLS]}.config.SMS`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.calls")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_SMS_CALLS]}.config.call`}
                                value={values?.precios?.[indexes[SERVICE_SMS_CALLS]]?.config?.call}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_SMS_CALLS]}.config.call`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                </>
                :null}
            {service === SERVICE_IMAGES?
                <>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.value")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_IMAGES]}.valor`}
                                value={values?.precios?.[indexes[SERVICE_IMAGES]]?.valor}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_IMAGES]}.valor`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                </>
                :null}
            {service === SERVICE_ADDITIONAL_API?
                <>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.farmApi")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_ADDITIONAL_API]}.config.farmAPI`}
                                value={values?.precios?.[indexes[SERVICE_ADDITIONAL_API]]?.config?.farmAPI}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_ADDITIONAL_API]}.config.farmAPI`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-4 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <label className="boldie">{t("billing.clientApi")}</label>
                        </div>
                        <div className="col-xl-5 col-lg-12 col-sm-12 text-md-left mtem-05">
                            <InputNumber className="buttonMidWidth"
                                name={`precios.${indexes[SERVICE_ADDITIONAL_API]}.config.clientAPI`}
                                value={values?.precios?.[indexes[SERVICE_ADDITIONAL_API]]?.config?.clientAPI}
                                onValueChange={(e) => setFieldValue(`precios.${indexes[SERVICE_ADDITIONAL_API]}.config.clientAPI`,e.value)}
                                minFractionDigits={minDecimals} maxFractionDigits={maxDecimals} showButtons step={0.25} min={0}
                            />
                        </div>
                        <div className="col-xl-1 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <label >USD</label>
                        </div>
                    </div>
                </>
                :null}
        </>
    );
};

export default withName(ServiceForm, "ServiceForm");
